import { render, staticRenderFns } from "./grid-legend-container.vue?vue&type=template&id=28b8658d&scoped=true&"
import script from "./grid-legend-container.vue?vue&type=script&lang=ts&"
export * from "./grid-legend-container.vue?vue&type=script&lang=ts&"
import style0 from "./grid-legend-container.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./grid-legend-container.vue?vue&type=style&index=1&id=28b8658d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8658d",
  null
  
)

export default component.exports